var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "v-container",
    {
      staticStyle: { "margin-top": "-25px" },
      attrs: { "grid-list-md": "", fluid: "" },
    },
    [
      _c(
        "v-layout",
        { attrs: { row: "" } },
        [
          _c("v-flex", { attrs: { xs5: "" } }, [_vm._v(" ")]),
          _vm._v(" "),
          _c(
            "v-flex",
            { attrs: { xs5: "" } },
            [
              _c("v-text-field", {
                attrs: { label: "Filter", clearable: "" },
                model: {
                  value: _vm.filter,
                  callback: function ($$v) {
                    _vm.filter = $$v
                  },
                  expression: "filter",
                },
              }),
            ],
            1
          ),
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "v-list",
        {
          staticStyle: { height: "250px", "overflow-y": "scroll" },
          attrs: { xs12: "", density: "compact", id: "list" },
        },
        _vm._l(_vm.filteredItems, function (item, i) {
          return _c(
            "v-list-item",
            { key: i, staticStyle: { padding: "0", "margin-top": "-25px" } },
            [
              _c(
                "v-flex",
                { attrs: { xs5: "", "mr-1": "" } },
                [
                  _c("v-text-field", {
                    on: { input: _vm.onChange },
                    model: {
                      value: item.name,
                      callback: function ($$v) {
                        _vm.$set(item, "name", $$v)
                      },
                      expression: "item.name",
                    },
                  }),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "v-flex",
                { attrs: { xs6: "" } },
                [
                  _c("v-textarea", {
                    attrs: { rows: "1" },
                    on: { input: _vm.onChange },
                    model: {
                      value: item.value,
                      callback: function ($$v) {
                        _vm.$set(item, "value", $$v)
                      },
                      expression: "item.value",
                    },
                  }),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "v-flex",
                { attrs: { xs1: "" } },
                [
                  _c(
                    "v-btn",
                    {
                      attrs: { text: "", icon: "" },
                      on: {
                        click: function ($event) {
                          return _vm.removeItem(i)
                        },
                      },
                    },
                    [
                      _c("v-icon", { attrs: { size: "small" } }, [
                        _vm._v("fal fa-trash"),
                      ]),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          )
        }),
        1
      ),
      _vm._v(" "),
      _c(
        "v-layout",
        { attrs: { xs12: "" } },
        [
          _c(
            "v-flex",
            { attrs: { xs5: "" } },
            [
              _c("v-text-field", {
                attrs: { label: "New Key" },
                model: {
                  value: _vm.newItem.name,
                  callback: function ($$v) {
                    _vm.$set(_vm.newItem, "name", $$v)
                  },
                  expression: "newItem.name",
                },
              }),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "v-flex",
            { attrs: { xs6: "" } },
            [
              _c("v-textarea", {
                attrs: { rows: "1", label: "New Value" },
                model: {
                  value: _vm.newItem.value,
                  callback: function ($$v) {
                    _vm.$set(_vm.newItem, "value", $$v)
                  },
                  expression: "newItem.value",
                },
              }),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "v-flex",
            { attrs: { xs1: "" } },
            [
              _c(
                "v-btn",
                {
                  attrs: { text: "", icon: "" },
                  on: {
                    click: function ($event) {
                      return _vm.addItem()
                    },
                  },
                },
                [
                  _c("v-icon", { attrs: { size: "small" } }, [
                    _vm._v("fal fa-check"),
                  ]),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
      _vm._v(" "),
      !_vm.hideButtons
        ? _c(
            "v-layout",
            {
              staticStyle: { "justify-content": "right" },
              attrs: { xs12: "" },
            },
            [
              _c(
                "v-btn",
                {
                  attrs: { text: "", color: "blue darken-1" },
                  on: { click: _vm.cancel },
                },
                [_vm._v("Cancel")]
              ),
              _vm._v(" "),
              _c(
                "v-btn",
                {
                  attrs: { text: "", color: "blue darken-1" },
                  on: { click: _vm.save },
                },
                [_vm._v("Save")]
              ),
            ],
            1
          )
        : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }